
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ApplicationFooter extends Vue {
  get getYear(): number {
    const date = new Date();
    return date.getFullYear();
  }

  public checkRoute(path: string): boolean {
    return path.startsWith('/main')
  }
}
